import { Col, Row, Space } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import ByMuvu from '../../../../PatientLandingGeneralComponents/ByMuvu';
import AppStoreES from "../../../../images/AppStoreES.svg";
import GooglePlayES from "../../../../images/GooglePlayES.svg";
import GreenCheckCircle from "../../../../images/GreenCheckCircle.svg";
import MuvuCMT from "../../../../images/MuvuCMT.svg";
import ContinueButton from '../../ContinueButton';


const ConsultationStep = ({ countryCode, stepHandler, getLocalStorageData }) => {

  return (
    <Row justify="center">
      {
        !stepHandler.finishSteps &&
        <Col span={24} className='mt-40'>
          <h2 className='text-center'>Consulta Médica</h2>
        </Col>
      }
      {
        stepHandler.finishSteps &&
          stepHandler.status === 'done' ?
          <Col span={24} className='mt-20'>
            <Row justify='center'>
              <Col span={24} xs={20} sm={20} lg={12} md={14} xl={10} className="text-center">
                <img className='mt-30' alt='check' src={GreenCheckCircle} width={50} />
              </Col>
              <Col span={24} className='mt-20 pl-50 pr-50'>
                <h3 className="text-green text-center">
                  ¡Haz finalizado tu proceso de atención en nuestro Centro Médico!
                </h3>
              </Col>
              <Col span={24} className='mt-20 pl-60 pr-60'>
                <p className="text-center">
                  El informe con los resultados de tus exámenes serán enviados a la empresa a la brevedad.
                </p>
              </Col>
              {
                (stepHandler.reviewCode && countryCode === 'CL') &&
                <Col span={24} className='mt-20 pl-60 pr-60'>
                  <p className="text-center">
                    <strong>El código para revisar exámenes es: {stepHandler.reviewCode}</strong>
                  </p>
                </Col>
              }
              {
                countryCode === 'CL' &&
                <>
                  <Col span={24} className='mt-20 pl-60 pr-60'>
                    <p className="text-center text-orange">
                      Recuerda descargar <strong>MUVU</strong> para ver los resultados de tus exámenes y guardar este código.
                    </p>
                  </Col>
                  <Col span={24} className='mt-20 pl-60 pr-60'>
                    <p className="text-center">
                      <strong>¡Muchas gracias!</strong>
                    </p>
                  </Col>
                  <Col span={24} className="text-center">
                    <Row justify='center'>
                      <Col span={24} xs={20} sm={20} lg={12} md={14} xl={10} >
                        <img className='mt-30 text-center' alt='check' src={MuvuCMT} width={200} />
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24} className='text-center'>
                    <Space size='large' className='mt-40 mb-20' >
                      <Link to='https://apps.apple.com/cl/app/muvu/id1189241762' target='_blank'>
                        <img alt='app store' src={AppStoreES} width={120} />
                      </Link>
                      <Link to='https://play.google.com/store/apps/details?id=org.vivosalud.vivosalud&pcampaignid=web_share' target='_blank'>
                        <img alt='google play' src={GooglePlayES} width={120} />
                      </Link>
                    </Space>
                  </Col>
                </>
              }
              {
                countryCode === 'PE' &&
                <>
                  <Col span={24} className='mt-20 pl-30 pr-30'>
                    <p className='text-center'>
                      Esperando que tu atención en <strong>Centro Médico del Trabajador</strong> haya sido satisfactoria. Te invitamos a responder una breve encuesta de calidad. Nos importa conocer tu opinión y seguir mejorando.
                    </p>
                  </Col>
                  <Col span={24} className='text-center'>
                    <Space size='large' className='mt-20 mb-20' >
                      <Link to='https://muvu.surveysparrow.com/s/encuesta-satisfaccin-cmt---magdalena-del-mar/tt-aRro4VCTvBuMAJP38NCX9b' target='_blank'>
                        Ir a Encuesta de Calidad
                      </Link>
                    </Space>
                  </Col>
                  <Col span={24} className='mt-20 pl-30 pr-30'>
                    <p className='text-center'>
                      <strong>¡Muchas Gracias!</strong>
                    </p>
                  </Col>
                </>
              }
              <Col span={24}>
                <ContinueButton stepHandler={stepHandler} getLocalStorageData={getLocalStorageData} />
              </Col>
            </Row>
          </Col>
        :
          <Col span={24} className="scrollable-col">
            <div className="scrollable-content">
              <Row justify='center'>
              {
                countryCode === 'CL' &&
                  <Col span={24} className='mt-20'>
                    <Row justify='center' className='border-container'>
                      <Col span={24}>
                        <h2 className="text-center text-orange">¡Queda muy poco!</h2>
                      </Col>
                      <Col span={24}>
                        <p className='text-center'>Avanzarás cuando te llamen del box correspondiente</p>
                      </Col>
                    </Row>
                  </Col>
              }
                <Col span={24} className='mt-20'>
                  {
                    <div className="exam-steps-container">
                      {
                        stepHandler.hasHealthConsultations &&
                        <div className={`exam-step  exam-step-${[stepHandler.unfinishHealthConsultation?.length > 0 ? 'waiting' : 'finished']}`}>
                          <span className="exam-step-color-bar"></span>
                          <span className="exam-step-title"><strong>Box Consulta médica</strong></span>
                        </div>

                      }
                      {
                        stepHandler.hasPsychologicalConsultations &&
                        <div className={`exam-step  exam-step-${stepHandler.unfinishPsychologicalConsultation?.length > 0 ? 'waiting' : 'finished'}`}>
                          <span className="exam-step-color-bar"></span>
                          <span className="exam-step-title"><strong>Box Consulta psicológica</strong></span>
                        </div>

                      }
                    </div>
                  }
                </Col>
                {
                  countryCode === 'CL' &&
                  <>
                    <Col span={24} className='mt-20 pl-30 pr-30'>
                      <p className='text-center'>
                        Podrás ver los resultados de tus exámenes de laboratorio en nuestra aplicación <strong>MUVU.</strong>
                      </p>
                      <p className='text-center'>
                        Solo tienes que descargar <strong>MUVU</strong>, validarte con el código que te entregamos al finalizar tu atención y estarás listo para ver tus resultados y además ganar puntos por cuidar tu salud y canjearlos por <strong>GIFT CARDS, DESCUENTOS y PREMIOS.</strong>
                      </p>
                      <p className='text-center text-orange pl-30 pr-30'>
                        ¡Cuida tu salud, gana y disfruta con <strong>MUVU!</strong>
                      </p>
                    </Col>
                    <Col span={24} className="text-center">
                      <Row justify='center'>
                        <Col span={24} xs={20} sm={20} lg={12} md={14} xl={10} >
                          <img className='mt-30 text-center' alt='check' src={MuvuCMT} width={200} />
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24} className='text-center'>
                      <Space size='large' className='mt-40 mb-20' >
                        <Link to='https://apps.apple.com/cl/app/muvu/id1189241762' target='_blank'>
                          <img alt='app store' src={AppStoreES} width={120} />
                        </Link>
                        <Link to='https://play.google.com/store/apps/details?id=org.vivosalud.vivosalud&pcampaignid=web_share' target='_blank'>
                          <img alt='google play' src={GooglePlayES} width={120} />
                        </Link>
                      </Space>
                    </Col>
                  </>
                }
                {
                  countryCode === 'PE' &&
                  <>
                    <Col span={24} className='mt-20 pl-30 pr-30'>
                      <p className='text-center'>
                        Esperando que tu atención en <strong>Centro Médico del Trabajador</strong> haya sido satisfactoria. Te invitamos a responder una breve encuesta de calidad. Nos importa conocer tu opinión y seguir mejorando.
                      </p>
                    </Col>
                    <Col span={24} className='text-center'>
                      <Space size='large' className='mt-20 mb-20' >
                        <Link to='https://muvu.surveysparrow.com/s/encuesta-satisfaccin-cmt---magdalena-del-mar/tt-aRro4VCTvBuMAJP38NCX9b' target='_blank'>
                          Ir a Encuesta de Calidad
                        </Link>
                      </Space>
                    </Col>
                  </>
                }
                <Col span={24}>
                  <ContinueButton stepHandler={stepHandler} getLocalStorageData={getLocalStorageData} />
                </Col>
                <Col span={24} className='mt-30'>
                  <ByMuvu />
                </Col>
              </Row>
            </div>
          </Col>
      }
    </Row>
  )
}

export default ConsultationStep;